import Client from './client';

export default class DiscountCodes extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  put(organization, number, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/orders/${number}/discount/codes`, {
      ...options,
       method: 'PUT',
    });
  }

  deleteByCode(organization, number, code, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/orders/${number}/discount/codes/${code}`, {
      ...options,
       method: 'DELETE',
    });
  }

}
